export default {
  mounting: {
    buttons: {
      edit: 'modifier',
      save: 'Enregistrer',
      close: 'Fermer',
      'add-video': 'Ajouter un média',
      'add-audio': 'Ajouter Audio',
      cursor: 'Sélectionner',
      hand: 'Glisser & déposer',
      undo: 'Annuler',
      redo: 'Refaire',
      refresh: 'Actualiser',
      cut: 'Couper',
      duplicate: 'Dupliquer',
      copy: 'Copier',
      paste: 'Coller',
      delete: 'Supprimer',
      cancel: 'Annuler',
      mic: 'Mic',
      preview: 'Visualisation',
      zoomin: 'Zoom +',
      zoomout: 'Zoom -',
      'upload-img': 'Sélectionner une image',
      'add-annotation': 'Ajouter',
      'edit-annotation': 'Modifier',
      'delete-annotation': 'Supprimer',
      'add-text': 'Ajouter texte',
      'add-picture': 'Ajouter une image',
      'add-pdf': 'Ajouter un pdf',
      ok: 'OK',
      start: 'Début',
      end: 'Fin',
    },
    shortkeys: {
      save: '(Ctrl + S)',
      undo: '(Ctrl + Z)',
      redo: '(Ctrl + Maj + Z)',
      cut: '(Ctrl + X)',
      duplicate: '(Ctrl + D)',
      copy: '(Ctrl + C)',
      paste: '(Ctrl + V)',
      delete: '(Suppr)',
      zoomin: '(Ctrl + +)',
      zoomout: '(Ctrl + -)',
    },
    tabs: {
      video: 'Vidéo',
      audio: 'Audio',
      image: 'Image',
      recording: 'Enregistrement...',
    },
    titles: {
      title: 'Titre',
      video: 'Vidéo',
      audio: 'Audio',
      text: 'Texte',
      image: 'Image',
      color: 'Couleur',
      backcolor: 'Arrière plan',
      'font-size': 'Taille',
      'font-family': 'Police',
      style: 'Style',
      go: 'Aller à:',
      'model-image': "Ajout d'image & logo",
      transitionLeft: 'Transition vers la droite',
      transitionRight: 'transition vers la gauche',
      transitionTop: 'transition vers le bas ',
      transitionBottom: 'transition vers le haut ',
      noTransition: 'Aucune transition',
      Transitionzoom: 'transition avec zoom',
      yoursearch: 'Aucun résultat trouvé pour',
      noresult: ' ',

      typeshow: {
        list: 'Liste',
        thumbnails: 'Vignettes',
      },
    },
    table: { thumbnail: 'Vignette', title: 'Titre', duration: 'Durée' },
    "effects": {
      "drag": "Mettez la vidéo ici"
    },
    "messages": {
      'confirm-delete': 'Etes-vous sûr de supprimer cette vidéo ?',
      'empty-cut': 'Rien à couper',
      'montage-cut': 'Découpé (zone de montage)',
      'montage-copy': 'Copié (montage area)',
      'player-copy': 'Copié (player), durée: ',
      'empty-insert': 'Rien à insérer',
      'player-insert': 'Insérée, durée: ',
      'success-delete': 'Les vidéos sont supprimées de la zone de montage',
      'save-montage-empty': "Il n'y a pas de vidéo dans la zone de montage !",
      'save-title-empty': 'Veuillez définir le titre de la vidéo',
      'save-success': 'Vidéo enregistrée',
      'success-add-video': 'Vidéo ajoutée',
      'success-add-image': 'Image ajoutée',
      'failed-add-image': "Image n'est pas valide",
      'success-add-audio': 'Audio ajoutée',
      'text-style-title': 'Style de texte',
      'transition-style-title': 'Transition',
      'choose-another-color': 'choisir une autre couleur',
      'empty-annotation-text': 'Texte vide, rien à insérer',
      'empty-annotation-image': 'Image vide, rien à insérer',
      'drop-image': "Déposez une image n'importe où",
      superposition: 'Superposition',
      'full-screen': 'Plein écran ',
    }
  },
  "subtitle": {
    "buttons": {
      add: 'Ajouter / Editer un sous-titrage',
      delete: 'Supprimer ce sous titre',
      save: 'Enregistrer',
      cancel: 'Annuler',
      'select-file': 'Choisissez un fichier',
      'open-upload-subtitles': 'Importer un fichier des sous-titres',
      'export-subtitles': 'Exporter les sous-titres dans un fichier',
      'transcription-subtitles': 'Transcription automatique',
      'transcription-review-subtitles': 'Transcription automatique avec relecture',
      'option-export-import': 'Exporter / importer un fichier',
      'download-prototype': 'Descendre',
    },
    "inputs": {
      "subtitle-content": "Sous-titrage"
    },
    "titles": {
      "start": "Début",
      "end": "Fin"
    },
    "messages": {
      "confirm-delete": "Voulez-vous supprimer ce sous-titre ?",
      "title-confirm-delete": "Supprimer",
      "confirm-delete-subtitles": "Voulez-vous supprimer les sous-titres existants ?",
      "list-transcription": "Sélectionnez le type de transcription que vous souhaitez le faire ",
      "error-add-subtitle": "Erreur de superposition des sous-titres",
      "error-add-subtitle-vide": "Le sous-titre est vide",
      "success-add-subtitle": "Sous-titre ajouté avec succès",
      "confirm-save": "Voulez-vous enregistrer les sous-titres ?",
      "success-save": "Enregistré avec succès",
      "empty-save": "Rien à sauvegarder",
      "drag-subtitles": "Déposez un fichier n'importe où pour charger les sous-titres",
      "error-uploded-file-type": "Choisissez un type valide (txt, srt, vtt)",
      "error-validate-file-type": "Fichier non valide",
      "upload-modal-title": "Charger un fichier de sous-titrage",
      "upload-modal-message-1": "Vous pouvez déposer un fichier de sous-titrage ici pour le télécharger. Attention, seuls les fichiers *.srt *.vtt *.txt sont autorisés et les formats texte (UTF-8 et AINSI) sont acceptés.",
      "upload-modal-message-2": "Les formats des différents types de sous-titrage:",
      "subtitles-exported": "Fichier des sous-titre exporté",
      "no-subtitles-to-export": "Pas de sous-titres à exporter",
      "change-lang": "Langue changée en ",
      "file-format-title": "Aperçu du fichier",
      "msg-error-input": "Erreur! Vérifiez votre saisie...",
      "txt-format": ";;00:00:00;;00:00:03;;This is the first title;;00:00:03;;00:00:05;;This is the second title",
      "srt-format": `
        1
        00:00:00,000 --> 00:00:03,000
        This is the first title
        
        2
        00:00:03,000 --> 00:00:05,000
        This is the second title`,
      "vtt-format": `
        WEBVTT

        1
        00:00:00.000 --> 00:00:03.000
        This is the first title
        
        2
        00:00:03.000 --> 00:00:05.000
        This is the second title`,
      "fr": "Français",
      "en": "Anglais",
      "es": "Espagnol",
      "it": "Italien",
    }
  },
  "editor": {
    "buttons": {
      "add": "Ajouter",
      "delete": "Supprimer",
      "save": "Enregistrer",
      "modify": "Modifier",
      "slide" : "Diapositive",
      "continue": "Continuer",
      "cancel": "Annuler",
      "save-modification": "Enregistrer les modifications",
      "download-prototype": "Descendre",
      "confirm" : "Confirmer"
    },
    "title": {
      "chapter": "Chapitre",
      "question": "Question",
      "quiz": "Quiz",
      "hidden-area": "Zone cachée",
      "sondage": "Sondage",
      "thumb": "Vignette",
      "video" : "Vidéo",
      "password" : "Authentification",
      "index-list" : "Liste",
      "save": "Enregistré",
      "cta": "Appel à agir",
      "slide": "Diapositive",
      "interactivity" : "Interactivités",
      "annotations" : "Annotations",
      "preview" : "Aperçu",
      navigation: 'Navigation',
      interactivity_with_timeline: 'Interactivité avec TimeLine',
      interactivity_without_timeline: 'Interactivité sans TimeLine',
    },
    "placeholder": {
      "add-chapter": "Ajouter un chapitre",
      "add-question": "Ajouter une question",
      insert_question: 'Votre question',
      insert_message: 'Votre message',
      "yes-no": "OUI / NON",
      "yes-no-nsp": "OUI / NON / NSP",
      "simple" : "Choix simple",
      "multiple" : "Choix multiple",
      "add-response" : "Ajouter une réponse",
      "title" : "Titre",
      "success-upload" : "Votre fichier a été téléchargé avec succès!",
      "open-upload-media": "Déposer un fichier",
      "or" : "ou",
      "select-file": "Choisissez un fichier",
      "generate-thumb": "Géneration d'une vignette",
      "loop" : "Lecture en boucle",
      "response" : "Réponse",
      "AddResponse" : "Ajouter une Réponse",
      "choice" : "Choix",
      "choiceButton" : "Ajouter un choix",
      "instant" : "Instant d'affichage: ",
      "duration" : "Durée d'affichage: ",
      "href" : "URL",
      "password" : "Vous devez saisir le mot de passe pour voir cette vidéo.",
      "text" : "Texte",
      "image" : "Image",
      "pdf" : "PDF"
    },
    "error": {
      "error" : "Erreur",
      "chapter-empty": "Ecrire un chapitre!",
      "error-message-time": "Erreur! Il existe un contenu dans cet instant, voulez vous supprimer le contenu précédent et continuer?",
      "error-message-time-overflow": "Erreur! Vous avez dépasser la durée de la vidéo",
      "msg-error-input": "Erreur! Vérifiez votre saisie...",
      "msg-error-slide-extension": "Erreur! Seulement les extensions (.jpeg), (.jpe), (.jpg), (.gif), (.png) et (.webp) sont acceptées",
      "msg-error-video-extension": "Erreur! Seulement l'extension .mp4 est acceptée",
      "error-xhr": "Une erreur s'est produite. Veuillez réessayer plus tard. Si le probléme persiste veuillez en informer votre responsable technique. Merci.",
      "error-flux" : "Flux de lecture introuvable",
      "error-flux-try-again" : "Erreur de flux, cliquez ici pour réessayer",
      "error-duration-null" : "La durée ne doit pas être nulle",
      "msg-error-cta-img-extension": "<h5 class='alert-heading'>Erreur!</h5> Seulement les extensions (.jpeg), (.jpe), (.jpg), (.gif), (.png) et (.webp) sont acceptées",
      "msg-error-cta-pdf-extension": "<h5 class='alert-heading'>Erreur!</h5> Seulement les fichiers PDFs sont acceptées",
      'api-error-title': 'Admin: Probléme Api',
      'api-error-msg': "L'IP n'appartient à aucune zone",
      'no-result-msg': "Le boitier n'est pas accessible",
      'no-result-video': "La vidéo en cours de traitement",
      'no-result': 'Aucun résultat trouvé',
      'api-zonning': 'connexion à api zoning echoué',
      'error-code': "code d'erreur",
      'video-not-found': 'Video non trouvée',
      'video-not-access': 'Accès refusé',
      email: 'Votre email',
      claim: 'Votre réclamation',
      submit: 'Envoyer',
    },
    "confirm": {
      "delete": "Voulez vous vraiment supprimer cet élement?"
    }
  },
  "worksapce": {
      "buttons": {
          "add-comment": "Commenter",
          "edit-comment": "Modifier",
          "hide-comment": "Masquer",
          "info-comment": "Info",
          "delete-comment": "Supprimer ce comentaire",
          "cancel-edit-comment": "Annuler",
          "reply-comment": "Répondre",
          "sort-asc": "Ordre croissant (le plus récent)",
          "sort-desc": "Ordre décroissant (le plus ancien)",
          "show-more": "Afficher plus",
          "show-less": "Afficher moins",
          "confirm-delete": "Confirmer",
          "cancel-delete": "Annuler",
          "add-reply": "Répondre",
      },
      "placeholder": {
          "write-something": "écrivez quelque chose ...",
        your_name: 'Votre nom',
      },
      "titles": {
          "comments": "Commentaires",
          "edit-button": "Modifier ce commentaire",
          "cancel-button": "Annuler la modification",
          "delete-button": "Supprimer ce commentaire",
          "show-comment": "Afficher ce commentaire",
          "refresh": "Actualiser"
      },
      "messages": {

      }
  },
  'dark-skin': {
  'general-information': 'Informations générales',
  'social-networks': 'Réseaux sociaux',
  'share-on': 'Partager sur:',
  'embed-the-video': 'Intégrer la video',
  'start-automatically': 'Démarrer la lecture automatiquement',
  'player-color': 'Couleur du player',
  'start-at': 'Démarrer la lecture à',
  embed: 'Intégration',
  'less-parameters': 'Moins de paramètres',
  'more-parameters': 'Plus de paramètres',
  'less-description': 'Lire moins',
  'more-description': 'Lire la suite',
  'attached-files': 'Fichiers jointes',
  chapters: 'Liste des chapitres',
  'download-all': ' Télécharger tout',
  'author-sheet': 'Fiche auteur',
  links: 'Liens',
  copy: 'Copier',
  '': '',
  // "": "",
  'email-modal': {
    title: 'Envoyer un email',
    'send-to': 'Envoyer à',
    from: 'De',
    subject: 'Sujet',
    message: 'Message',
    sending: 'Envoi en cours...',
    send: 'Envoyer',
    // "": "",
    messages: {
      'invalid-email': 'Email invalide!',
      'field-required': 'Ce champ est obligatoire!',
      'thank-you': 'Merci!',
      'message-sent': 'Votre message a bien été envoyé',
      'back-to-video': 'Revenir au site',
      oops: 'Oops!',
      'error-occurred': "Une erreur s'est produite pendant l'envoi du message",
      'try-again': 'Essayer de nouveau',
      // "": "",
    },
  },
  'contact-form':{
    title:'Pour découvrir nos logiciels, indiquez nous vos coordonnées et nous vous recontacterons',
    name:'Nom ',
    lastName:'Prénom',
    email:'Email ',
    tel:'Téléphone',
    soc:'Société',
    'function':'Fonction',
    text:'Texte',
    link:'Visiter notre site',
    submit:'Envoyer',
    messages: {
      'invalid-email': 'Email invalide!',
      'field-required': 'Ce champ est obligatoire!',
      'thank-you': 'Merci!',
      'message-sent': 'Votre message a bien été envoyé',
      'back-to-video': 'Revenir au site',
      oops: 'Oops!',
      'error-occurred': "Une erreur s'est produite pendant l'envoi du message",
      'try-again': 'Essayer de nouveau',
      // "": "",
    },
    contact:"Merci de nous avoir contacté.",
    description:"Notre équipe vous recontactera rapidement "

  }
},
    captions:{
        "save": "Enregistrer",
        "export": "Publier",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/fr_FR.js